import countries from "utils/static/countries";
import { get } from "../client";

import {
    getList as _getList,
    getAll as _getAll,
    add as _add,
    update as _update,
    deleteAll as _deleteAll,
    getAsync as _getAsync,
    getListAsync as _getListAsync,
    patchAsync as _patchAsync,
    getAsyncWithThrow as _getAsyncWithThrow,
} from "../api";

let BASE_URL = null;
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "id",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 5,
};

export function initDB(dbName) {
    BASE_URL = `/modules/${dbName}/file-cases`;
}

export function getAll({ onSuccess, onError, normalizeData }) {
    _getAll({ url: BASE_URL, onSuccess, onError, normalizer: normalizeData });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA, normalizeData }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}
export async function getListAsync(data = DEFAULT_LIST_DATA, normalizeData) {
    return _getListAsync({ url: BASE_URL, data, normalizer: normalizeData });
}

export async function getOneByIdAsync(id, normalizeData) {
    return _getAsync({ url: `${BASE_URL}/${id}`, normalizer: normalizeData });
}

export async function startNewWorkflow(id) {
    return _patchAsync({ url: `${BASE_URL}/${id}/start-new-workflow` });
}

export async function startNewConversation(id, userId) {
    return _patchAsync({ url: `${BASE_URL}/${id}/start-new-conversation`, data: { userId } });
}

export async function getNextConsecutiveAsync() {
    return _getAsync({ url: `${BASE_URL}/consecutive` });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}

export async function changeWorkStatus(id, workStatus) {
    return _patchAsync({ url: `${BASE_URL}/${id}:change-work-status`, data: workStatus });
}

export async function changeAssigneeUser(id, assigneeUserId) {
    return _patchAsync({ url: `${BASE_URL}/${id}:change-assignee`, data: { assigneeUserId } });
}

export async function changeDueDate(id, dueDate) {
    return _patchAsync({ url: `${BASE_URL}/${id}:change-due-date`, data: { dueDate } });
}

function normalizeStatus(data, moduleCode) {
    return data.filter((x) => x.modules.some((y) => y.code === moduleCode));
}

function normalizeTypes(data, moduleCode) {
    return data.filter((x) => x.module.code === moduleCode);
}

function processError(error, callback) {
    const { response } = error;
    if (response && response.data) {
        callback(response.data);
    } else {
        callback("Network error!");
    }
}

export async function getResources({ moduleCode, onSuccess, onError }) {
    const resources = {
        countries,
        cities: [],
        states: [],
    };

    try {
        const response = await get({ url: `${BASE_URL}/resources/${moduleCode}` });
        const status = normalizeStatus(response.data.status, moduleCode);
        const types = normalizeTypes(response.data.types, moduleCode);
        const contactTypes = response.data.contactTypes;
        const fileLocations = response.data.fileLocations;
        const users = response.data.users;
        onSuccess({ ...resources, status, types, contactTypes, fileLocations, users });
    } catch (error) {
        processError(error, onError);
    }
}

// Only for immigration cases
export async function getUscisCaseStatusAsync(id, receiptNumber) {
    if (!BASE_URL.includes("immigration") || !id || !receiptNumber) {
        return Promise.resolve(null);
    }
    return _getAsyncWithThrow({ url: `${BASE_URL}/${id}/uscis-case-status/${receiptNumber}` });
}
